import type { SearchState, SearchTermType, SearchTextType, SortValue } from './types';

export function toNumber(value: unknown, fallback = 0): number {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export function toSearchTermType(value: unknown): SearchTermType {
  const v = toNumber(value, 1);
  if (v === 2 || v === 3) return v;
  return 1;
}

export function toSortValue(value: unknown): SortValue {
  const v = toNumber(value, 0);
  if (v === 1 || v === 2) return v;
  return 0;
}

export function toSearchTextType(value: unknown): SearchTextType {
  const v = toNumber(value, 0);
  if (v === 1 || v === 2 || v === 3) return v;
  return 0;
}

export function normalizeSearchTextFields(search: SearchState): SearchState {
  return {
    ...search,
    search_patient_id: search.search_text === 1 ? search.search_patient_id : '',
    search_patient_name: search.search_text === 2 ? search.search_patient_name : '',
    ini: search.search_text === 3 ? search.ini : '',
  };
}
